module.exports = __webpack_public_path__ + "img/trend-down.8a7af4c8.svg";